import { FtlRouteViewModel } from "../ViewModel/FtlRouteViewModel";
import { fetchTemplateFtlRoutes } from "./FetchTemplateFtlRoutes";

export const getTemplateFtlRoutes = async (
  routesOnThisProject: Array<FtlRouteViewModel> | undefined
) => {
  if (!routesOnThisProject) {
    return [];
  }

  const listOfRouteNumbers: Array<string> = [];

  routesOnThisProject.forEach((route) => {
    if (!route.RouteNumber) {
      return;
    }
    listOfRouteNumbers.push(route.RouteNumber);
  });

  return fetchTemplateFtlRoutes(listOfRouteNumbers);
};
